import { InProgressIcon } from '@/elements/ballot-state-icon'
import * as React from 'react'
import { css } from 'styled-components/macro'

const Root = 'div'

interface Props extends React.ComponentPropsWithoutRef<typeof Root> {}

function LiveUpdate(props: Props) {
  return (
    <Root {...props} css={styles.root as any}>
      <InProgressIcon color="currentColor" size={18} variant="dot" />
    </Root>
  )
}

const styles = {
  root: css`
    display: flex;
  `,
}

export default LiveUpdate
